import { cn } from '@rocco/utils/cn';
import type { UserActiveStatus } from '~/modules/user';

/**
 * The user status indicator dot, shown next to the user avatar.
 */
export function StatusIndicator({
    className,
    status,
}: {
    className?: string;
    status: UserActiveStatus;
}) {
    return (
        <span
            className={cn(
                // border + aspect-ratio fails on Safari, so have to do this instead.
                'absolute bottom-[-8%] right-[-8%] grid aspect-square h-[35%] place-items-center rounded-full bg-white',
                status === 'inactive' && 'hidden',
                className,
            )}
            aria-label={status === 'active' ? 'Active' : 'Inactive'}
        >
            <span
                className={cn(
                    'size-[calc(100%-4px)] rounded-full bg-[#9CA3AF]',
                    status === 'active' && 'bg-[#01754F]',
                )}
            ></span>
        </span>
    );
}
